/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./empty-view.vue?vue&type=template&id=fb8c24c8&scoped=true&"
import script from "./empty-view.vue?vue&type=script&lang=ts&"
export * from "./empty-view.vue?vue&type=script&lang=ts&"
import style0 from "./empty-view.vue?vue&type=style&index=0&id=fb8c24c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c24c8",
  null
  
)

export default component.exports